import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TechModule } from '@schir-int-client/tech';

@Component({
	selector: 'schir-int-client-checkboxes',
	templateUrl: 'checkboxes.component.html',
	styleUrls: ['checkboxes.component.scss'],
	imports: [ReactiveFormsModule, MatListModule, MatFormFieldModule, TechModule],
})
export class CheckboxesComponent<T> {
	@Input() legend: string;
	@Input() errorText: string;
	@Input({ required: true }) values: T[];
	@Input({ required: true }) labels: { [p: string]: string };
	@Input({ required: true }) control: FormControl<T[]>;
}
